import React, { useState } from "react";
import axios from "axios";
import { Mail, ArrowRight } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterCTA() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("You're on the list. New work, first.");
      setEmail("");
    } catch (err) {
      toast.error("Couldn't subscribe. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section
      className="border-t border-border bg-foreground text-background"
      data-testid="newsletter-cta"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-7">
          <img
            src="/jgj-logo-light.png"
            alt="Joseph Graves Jr."
            className="h-16 md:h-20 w-auto object-contain mb-8 opacity-95"
          />
          <p className="label !text-background/60 mb-4">Studio Dispatch — Private List</p>
          <h2 className="serif text-4xl md:text-5xl leading-[1.05] tracking-tight font-light">
            First look at new releases,
            <br />
            <span className="italic text-background/70">
              exclusive print drops, and studio invitations.
            </span>
          </h2>
          <p className="mt-6 text-sm text-background/60 max-w-lg">
            A few emails a year, no spam. Subscribers see new originals before
            they're posted publicly and receive priority on limited-edition
            prints.
          </p>
        </div>
        <form
          onSubmit={submit}
          className="md:col-span-5"
          data-testid="newsletter-form"
        >
          <div className="flex border-b border-background/40 pb-2">
            <Mail className="h-5 w-5 self-center mr-3 opacity-70" />
            <input
              type="email"
              required
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 bg-transparent outline-none placeholder:text-background/40 text-base py-3"
              data-testid="newsletter-email-input"
            />
            <button
              type="submit"
              disabled={busy}
              className="inline-flex items-center gap-2 label !text-background"
              data-testid="newsletter-submit"
            >
              {busy ? "..." : "Subscribe"}
              <ArrowRight className="h-3.5 w-3.5" />
            </button>
          </div>
          <p className="text-xs text-background/50 mt-3">
            ~4 emails a year. New work first. Unsubscribe anytime. Never shared.
          </p>
        </form>
      </div>
    </section>
  );
}
